import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {
  InteractiveListItem,
  InteractiveListItemPublicProps,
} from '../../../../../../libs/shared/ui/src/components/interactiveList/interactiveListItem';
import {SearchToken} from '../../../../../../srcCommon/inboxes/search/searchQueryHelpers';
import {InboxesSearchSuggestionItemProps} from './inboxesSearchSuggestionsDropdownCommons';
import {SearchSuggestionsDropdownItemContent} from './searchSuggestionsDropdownItemContent';
import {
  SearchSuggestionsDropdownItemIcon,
  SearchSuggestionsDropdownItemIconProps,
} from './searchSuggestionsDropdownItemIcon';

/*
 * Props.
 */

interface SearchSuggestionsDropdownItemProps
  extends InteractiveListItemPublicProps,
    SearchSuggestionsDropdownItemIconProps,
    InboxesSearchSuggestionItemProps {
  activeToken: SearchToken;
}

/*
 * Style.
 */

export const StyledSearchSuggestionsDropdownItemDiv = styled.div<{$isHighlighted: boolean}>`
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-gap: 8px;
  grid-template-areas: 'icon content';
  align-items: center;
  justify-items: left;

  overflow: hidden;

  padding: 0 16px;
  height: 30px;

  ${(p) =>
    p.$isHighlighted &&
    css`
      background-color: ${p.theme.greys.shade10};
    `};
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownItem: FC<SearchSuggestionsDropdownItemProps> = (props) => {
  const {
    activeToken,
    label,
    value,
    valuePlaceholder,
    fuzzyQuery,
    icon,
    iconName,
    iconColor,
    ...interativeListItemProps
  } = props;

  return (
    <InteractiveListItem {...interativeListItemProps}>
      {({itemProps, isHighlighted}) => (
        <StyledSearchSuggestionsDropdownItemDiv {...itemProps} $isHighlighted={isHighlighted}>
          <SearchSuggestionsDropdownItemIcon icon={icon} iconName={iconName} iconColor={iconColor} />
          <SearchSuggestionsDropdownItemContent
            label={label}
            value={value}
            valuePlaceholder={valuePlaceholder}
            fuzzyQuery={fuzzyQuery ?? activeToken.value}
            isHighlighted={isHighlighted}
          />
        </StyledSearchSuggestionsDropdownItemDiv>
      )}
    </InteractiveListItem>
  );
};
